import { render } from "./SimpleBarGraph.vue?vue&type=template&id=0bf022b6&scoped=true"
import script from "./SimpleBarGraph.vue?vue&type=script&lang=js"
export * from "./SimpleBarGraph.vue?vue&type=script&lang=js"

import "./SimpleBarGraph.vue?vue&type=style&index=0&id=0bf022b6&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bf022b6"]])

export default __exports__